import { render, staticRenderFns } from "./EmptyResultLaudo.vue?vue&type=template&id=5756a630&scoped=true&lang=pug"
import script from "./EmptyResultLaudo.vue?vue&type=script&lang=js"
export * from "./EmptyResultLaudo.vue?vue&type=script&lang=js"
import style0 from "./EmptyResultLaudo.vue?vue&type=style&index=0&id=5756a630&prod&lang=scss&scoped=true"
import style1 from "./EmptyResultLaudo.vue?vue&type=style&index=1&id=5756a630&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5756a630",
  null
  
)

export default component.exports